<form name="userForm" class="form">
    <div *ngFor="let pref of searchPrefs">
    	<div *ngIf="resultsPrefs.includes(pref.name)" class="form-group row">    
	        <div class="col-xs-5 control-label"> {{pref.displayName}} </div>
	        <div class="col-xs-7">
	            <input 
	            	*ngIf="!pref.optionElementList || pref.optionElementList.length == 0" 
	            	type="text" 
	            	[(ngModel)]="pref.value" 
	            	[id]="pref.name"
	            	[name]="pref.name"
	            	class="form-control" />	            
				<select 
				  *ngIf="pref.optionElementList?.length" 
				  [(ngModel)]="pref.value"
	              [id]="pref.name"
	              [name]="pref.name"				  
				  class="form-control">
				  <option *ngFor="let option of pref.optionElementList" [value]="option.value">
				    {{ option.name }}
				  </option>
				</select>
	        </div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-xs-5 control-label"> {{LOCALIZATION.sortBy}} </div>
        <div class="col-xs-7">
            <table class="table table-condensed table-hover" style="table-layout:fixed">
                <thead>
                <tr>
                    <th>{{LOCALIZATION.sortType}}</th>
                    <th>{{LOCALIZATION.field}}</th>
                    <th>{{LOCALIZATION.sortAscending}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let prefs of sortPrefs; let i = index;">
                    <td class="truncate">
					  <select [(ngModel)]="prefs.keyType" [id]="'sort' + i" [name]="'sort' + i" class="form-control">
					    <option *ngFor="let option of keyTypeOptions" [ngValue]="option.value">
					      {{ option.name }}
					    </option>
					  </select>                        
                    </td>
                    <td class="truncate">
					  <select *ngIf="prefs.keyType && prefs.keyType !== 2" 
					  	[(ngModel)]="prefs.fieldName" 
					  	[id]="'sortfield' + prefs.fieldName + i" 
					  	[name]="'sortfield' + prefs.fieldName + i" 
					  	class="form-control">
						    <option *ngFor="let option of fieldPrefs" [ngValue]="option.name">
						      {{ option.displayName }}
						    </option>
					  </select>                    	
                    </td>
                    <td class="text-center">
                        <label class="control control--checkbox">
                            <input 
                            	type="checkbox" 
								[(ngModel)]="prefs.isAscending"
					            [id]="'isAscending' + prefs.fieldName + i"
					            [name]="'isAscending' + prefs.fieldName + i" />
                            <div class="control__indicator"></div>
                        </label>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <br>
   	<button 
   		type="submit" 
   		class="btn btn-primary pull-right" 
   		(click)="updatePreferences()" 
   		title="Update search preferences">
   			{{LOCALIZATION.update}}
   	</button>
</form>